import { render, staticRenderFns } from "./deviceDistribution.vue?vue&type=template&id=2893139d&scoped=true&"
import script from "./deviceDistribution.vue?vue&type=script&lang=js&"
export * from "./deviceDistribution.vue?vue&type=script&lang=js&"
import style0 from "./deviceDistribution.vue?vue&type=style&index=0&id=2893139d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2893139d",
  null
  
)

export default component.exports